<template>
    <content-link-edit v-if="content" :content="content" :back-route="{ name: 'client-content-links', params: { clientId: clientId } }" />
</template>
<script>
import contentService from '../../../../../services/content.service'

import ContentLinkEdit from '../../../../common/content/link/content-link-edit.vue'

export default {
    name: 'system-content-link-edit',
    components: { ContentLinkEdit },
    data() {
        return {
            content: null
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        contentId() {
            return this.$route.params.contentId;
        }
    },
    async created() {
        this.content = await contentService.getLink(this.contentId);
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/links/edit.vue